const DEFAULT_DATA = {
  conditionProperties: [
    {
      data: {
        resource: 'project',
        includeIds: null,
      },
    },
    {
      data: {
        resource: 'employees',
        includeIds: null,
      },
    },
  ],
  recipients: undefined,
  description: undefined,
  headline: undefined
}

export default DEFAULT_DATA
